<template>
    <vue-phone-number-input
            v-model="internalValue"
            @update="setCode"
            :required="!internalValue"
            type="text"
            color="#252C65"
            defaultCountryCode="ZW"
            :onlyCountries="countries"
            :isValid="error"
            :noExample="true"
            :showCodeOnList="true"
            :clearable="true"
            :disabled="disabled"
            size="lg">
    </vue-phone-number-input>
</template>

<script>
    import VuePhoneNumberInput from 'vue-phone-number-input';
    import 'vue-phone-number-input/dist/vue-phone-number-input.css';

    export default {
        name: "phone-input",
        props: ['value', 'countries', 'error' , 'disabled'],
        components: {
            'vue-phone-number-input': VuePhoneNumberInput
        },
        data: () => ({
            internalValue: '',
            code: '263'
        }),
        watch: {
            internalValue(v) {
                if (v && v.startsWith('0')) {
                    this.internalValue = v.substring(1)
                }

                if (v && this.code && v.startsWith(this.code)) {
                    this.internalValue = v.substring(this.code.length)
                }

                this.$emit('input', v ? (this.code + v).replace(/ /g, '') : v)
            },
            value(v) {
                if (v && !v.startsWith(this.code)) {
                    this.internalValue = v
                }
            },
        },
        methods: {
            setCode(ev) {
                this.code = ev.countryCallingCode || '263'
            },
        },
        mounted() {
             this.internalValue = this.value
        }
    }
</script>

<style scoped>

</style>
